module.exports = __webpack_public_path__ + "static/media/BalancoFinanc5.77fbb59d.png";


//////////////////
// WEBPACK FOOTER
// ./src/imagens/RelBalancoFinanc/BalancoFinanc5.png
// module id = 2175
// module chunks = 0